var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mail-users" } }, [
    _vm.visitors.length > 0
      ? _c(
          "div",
          [
            _c(
              "a-table",
              {
                key: "vtable-" + _vm.renderCount,
                attrs: {
                  columns: _vm.cols,
                  dataSource: _vm.visitors,
                  pagination: false,
                  rowClassName: _vm.getRowClassName,
                  loading: _vm.loading,
                  locale: {
                    emptyText: _vm.$t("message.noVisitorFound"),
                  },
                  rowKey: "_id",
                  size: "small",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "fullname",
                      fn: function (text, record) {
                        return [
                          _c("div", { staticClass: "avatar-cell" }, [
                            _c(
                              "span",
                              {
                                staticClass: "user-segment-avatar text-center",
                                class: {
                                  "user-segment-avatar-odd":
                                    _vm.isRowNumberOdd(record),
                                },
                              },
                              [
                                _c(
                                  "md-highlight-text",
                                  {
                                    staticClass: "text-center",
                                    attrs: { "md-term": "term" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          record.fullname
                                            ? record.fullname
                                                .slice(0, 1)
                                                .toUpperCase()
                                            : ""
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "white-space" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(record.fullname) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "tags",
                      fn: function (data, item) {
                        return [
                          _c(
                            "span",
                            { staticClass: "tags" },
                            _vm._l(data || [], function (tag) {
                              return _c("span", { staticClass: "tag" }, [
                                _c("span", {
                                  staticClass: "tag-color",
                                  style: "background:" + tag.color,
                                }),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(tag.name) +
                                    "\n                    "
                                ),
                              ])
                            }),
                            0
                          ),
                        ]
                      },
                    },
                    {
                      key: "connectionTime",
                      fn: function (data, item) {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.fixDate(data)) +
                              "\n            "
                          ),
                        ]
                      },
                    },
                    {
                      key: "connectionTimeSlot",
                      fn: function (data, item) {
                        return _c("div", {}, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("date")(item.connectionTime)) +
                              "\n            "
                          ),
                        ])
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _vm._v(" "),
                _vm._v(" "),
                _vm._v(" "),
                _vm._l(_vm.colValues, function (value) {
                  return _c(
                    "span",
                    { attrs: { slot: value.slot }, slot: value.slot },
                    [
                      value["enabled"] === true
                        ? _c("span", [
                            value.icon === "playlist_add"
                              ? _c(
                                  "span",
                                  { staticStyle: { cursor: "pointer" } },
                                  [
                                    _c(
                                      "a-popover",
                                      {
                                        attrs: {
                                          placement: "leftTop",
                                          trigger: "click",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "title",
                                              fn: function () {
                                                return [
                                                  _c("a-checkbox", {
                                                    attrs: {
                                                      checked:
                                                        _vm.showAllColumns,
                                                    },
                                                    on: {
                                                      click: function (e) {
                                                        return _vm.onSelectShowAllColumns(
                                                          e
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#516173",
                                                        "margin-left": "5px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Show in columns: "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "content",
                                              fn: function () {
                                                return _vm._l(
                                                  _vm.colValues,
                                                  function (value, key, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key:
                                                          key + value + index,
                                                        staticStyle: {
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                        },
                                                        on: {
                                                          click: function (e) {
                                                            return _vm.selectedClick(
                                                              value,
                                                              key,
                                                              e
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        value.title !== ""
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                style:
                                                                  _vm.validCols.includes(
                                                                    value.slot
                                                                  )
                                                                    ? ""
                                                                    : "cursor: pointer",
                                                              },
                                                              [
                                                                _c("input", {
                                                                  key:
                                                                    key +
                                                                    value[
                                                                      "enabled"
                                                                    ],
                                                                  staticStyle: {
                                                                    "margin-right":
                                                                      "6px",
                                                                  },
                                                                  attrs: {
                                                                    type: "checkbox",
                                                                    disabled:
                                                                      _vm.validCols.includes(
                                                                        value.slot
                                                                      ),
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      value[
                                                                        "enabled"
                                                                      ],
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons mx-2 text-primary operation-button",
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "#006cff",
                                                                        "margin-right":
                                                                          "10px",
                                                                        "font-size":
                                                                          "17px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                            " +
                                                                        _vm._s(
                                                                          value.icon
                                                                        ) +
                                                                        "\n                                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "checkbox-label",
                                                                    style:
                                                                      _vm.validCols.includes(
                                                                        value.slot
                                                                      )
                                                                        ? ""
                                                                        : "cursor: pointer",
                                                                    attrs: {
                                                                      for: key,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        value.title
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                )
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "material-icons mx-2 text-primary operation-button",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(value.icon) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "span",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "material-icons mx-2 text-primary operation-button",
                                      },
                                      [_vm._v(" " + _vm._s(value.icon) + " ")]
                                    ),
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(value.title) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("Pagination", {
              staticClass: "pagination",
              attrs: {
                "page-change": _vm.pageChange,
                pageSizes: _vm.pageSizes,
                total: _vm.total,
                pageSizeLocalStorageKey: "visitor-history-page-size",
              },
            }),
          ],
          1
        )
      : _c("div", { staticClass: "data-box" }, [
          _c("div", { staticClass: "last-session-info" }, [
            _c(
              "div",
              {
                staticClass: "material-icons",
                staticStyle: { "font-size": "20px" },
              },
              [_vm._v("block")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "last-session-data",
                staticStyle: { "margin-top": "5px" },
              },
              [_vm._v(_vm._s(_vm.$t("visitor.notUserData")))]
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }